<template>
  <div
    class="search_input--inner"
    :class="[`inner-size-${size}`]"
    @mouseenter="handleInputEnter"
    @mouseleave="handleInputLeave"
  >
    <SjInput
      class="input"
      ref="input"
      v-bind="$attrs"
      :disabled="disabled"
      :size="size"
      :value="value"
      @input="$emit('input', $event)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @keyup.enter.native="search"
    />
    <div
      class="search-icon"
      :class="{ highlightFocus, highlightIcon, disabled }"
      @click="handleIconClick"
    >
      <i
        :class="[
          'icon_com',
          showClear
            ? 'commulti_close search-icon--clear'
            : 'cominputsearch_search'
        ]"
      />
    </div>
  </div>
</template>

<script>
import sizeMixin from "../../../utils/sizeMixin";

export default {
  mixins: [sizeMixin],
  props: {
    clearable: Boolean,
    clearAfterSearch: Boolean,
    clearForce: Boolean,
    disabled: Boolean,
    stopSearchClickEvent: Boolean,
    highlightFocus: {
      type: Boolean
    },
    highlightIcon: {
      type: Boolean
    },
    value: {
      type: String
    }
  },
  data() {
    return {
      isHovering: false,
      searched: false,
      searchedValue: null
    };
  },
  computed: {
    showClear() {
      const {
        clearForce,
        clearable,
        value,
        searchedValue,
        isHovering,
        searched,
        clearAfterSearch
      } = this;
      return clearForce
        ? isHovering
        : clearable &&
            value &&
            isHovering &&
            (clearAfterSearch ? searched && value === searchedValue : true);
    }
  },
  methods: {
    handleInputEnter() {
      this.isHovering = true;
    },
    handleInputLeave() {
      this.isHovering = false;
    },
    handleIconClick(event) {
      const { showClear, stopSearchClickEvent } = this;
      if (showClear) {
        this.handleFocus();
      }
      this.$nextTick(() => {
        this.search();
      });
      if (stopSearchClickEvent) {
        event.stopPropagation();
      }
    },
    search() {
      const { value } = this;
      if (value) {
        this.searched = true;
      } else {
        this.searched = false;
      }
      this.searchedValue = value;
      this.$emit("search", value);
    },
    focus() {
      this.$refs.input.focus();
    },
    handleFocus() {
      this.$emit("input", null);
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">
.search_input--inner {
    width: 100%;
    display: flex;
    align-items: center;
    .search-icon-active() {
        &:not(.disabled) {
            &.highlightFocus {
                background: @color-available;
            }

            &.highlightIcon {
                i {
                    color: @color-antibg;
                }
            }
        }
    }
    .input {
        flex-grow: 1;
        &:focus {
            + .search-icon {
                .search-icon-active();
            }
        }
    }

    .search-icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .5s;
        transition-timing-function: ease-in-out;
        cursor: pointer;
        &.disabled{
            cursor: not-allowed;
            i{
                color:@color-light;
            }
        }

        i {
            color:@color-normal;
        }

        .search-icon--clear {
          font-size: 12px;
        }

        &:hover,
        &:active {
            .search-icon-active();
        }
    }

    each(@sizes, {
        &.inner-size-@{value} {
            @size: "@{value}-size";
            .search-icon {
                width: @@size;
                height: @@size;
                i {
                  .icon_size(@value);
                }
            }
        }
    });
}
</style>
